import { ColumnTable, Icon } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SummaryDetail } from '../../../../types/collection-management';
import { formatCurrency } from '../../../../utils/currency';
import { formatDate } from '../../../../utils/date';

export default function useTableColumns() {
  const { t } = useTranslation();

  const columns: ColumnTable<SummaryDetail>[] = useMemo(() => {
    const tariffFormatter = formatCurrency({ symbol: false });

    return [
      {
        columnName: 'docnum',
        thClassName: 'text-center',
        tdClassName: 'text-center fw-700',
        headerText: t(`common.terms.docNum`),
      },
      {
        columnName: 'doctype',
        headerText: t(`common.terms.document`),
      },
      {
        columnName: 'date',
        headerText: t(`common.terms.date`),
        cellFormat: ({ row }) => {
          return formatDate(row.date, 'YYYY-MM-DD');
        },
      },
      {
        columnName: 'share',
        headerText: t(`common.terms.cuota`),
      },
      {
        columnName: 'expiration',
        headerText: t(`common.terms.expiration`),
        cellFormat: ({ row }) => {
          return formatDate(row.expiration, 'YYYY-MM-DD');
        },
      },
      {
        columnName: 'rut',
        headerText: t(`common.terms.rut`),
        cellFormat: ({ row }) => {
          return row.rut;
        },
      },
      {
        columnName: 'clientName',
        headerText: t(`common.terms.firstName`),
      },
      {
        columnName: 'amount',
        headerText: t(`common.terms.count`),
        cellFormat: ({ row }) => {
          return tariffFormatter.format(Number(row.amount));
        },
      },
      {
        columnName: 'reliable',
        headerText: t(`common.terms.reliable`),
        cellFormat: ({ row }) => {
          return tariffFormatter.format(Number(row.reliable));
        },
      },
      {
        columnName: 'balance',
        headerText: t(`common.terms.amount`),
        cellFormat: ({ row }) => {
          return tariffFormatter.format(Number(row.balance));
        },
      },
      {
        columnName: 'observations',
        thClassName: 'text-center',
        tdClassName: 'text-center fw-700',
        headerText: t(`common.terms.observations`),
        cellFormat: ({ row }) => {
          return (
            <div
              style={{ cursor: 'pointer' }}
              onClick={() => null}
              title="detail"
            >
              <Icon className="mt-0" name="eye" size="24px" color="secondary" />
            </div>
          );
        },
      },
    ];
  }, [t]);

  return columns;
}
